














































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Project extends Vue {
  @Prop() private projectTitle!: String;
  @Prop() private projectSubtitle!: String;
  @Prop() private projectLink!: String;
  @Prop() private playStoreLink!: String;
  @Prop() private languagesUsed!: String[];
  @Prop() private frameworksUsed!: String[];
  @Prop() private conceptsUsed!: String[];
  @Prop() private projectPicSrcs!: String[];
}
